import { tokens } from './tokens'

const light = {
  background: tokens.color.white,
  backgroundHover: tokens.color.black4,
  backgroundPress: tokens.color.black5,
  backgroundFocus: tokens.color.black4,
  borderColor: tokens.color.black5,
  borderColorHover: tokens.color.black4,
  borderColorPress: tokens.color.black5,
  borderColorFocus: tokens.color.black4,
  color: tokens.color.black10,
  colorHover: tokens.color.black10,
  colorPress: tokens.color.black10,
  colorFocus: tokens.color.black10,
  shadowColor: tokens.color.black6,
  outlineColor: tokens.color.black10,
}

export type BaseTheme = typeof light

export const themes: Record<string, Partial<BaseTheme>> = {
  light,
  // not sure what dark mode should look like
  // but it's just an example
  dark: light,
  light_Button: {
    color: tokens.color.white,
    background: tokens.color.red6,
    backgroundHover: tokens.color.red5,
    backgroundPress: tokens.color.red7,
    borderColor: tokens.color.red6,
    borderColorHover: tokens.color.red5,
    borderColorPress: tokens.color.red7,
    outlineColor: tokens.color.black10,
  },
  light_secondary_Button: {
    color: tokens.color.red6,
    background: tokens.color.white,
    backgroundHover: tokens.color.red1,
    backgroundPress: tokens.color.red2,
    borderColor: tokens.color.red6,
    borderColorHover: tokens.color.red4,
    borderColorPress: tokens.color.red2,
  },
  dark_Button: {
    color: tokens.color.red6,
    background: tokens.color.white,
    backgroundHover: tokens.color.red1,
    backgroundPress: tokens.color.red2,
    borderColor: tokens.color.white,
    borderColorHover: tokens.color.red1,
    borderColorPress: tokens.color.red2,
  },
  dark_secondary_Button: {
    color: tokens.color.white,
    background: tokens.color.red6,
    backgroundHover: tokens.color.red7,
    backgroundPress: tokens.color.red8,
    borderColor: tokens.color.white,
    borderColorHover: tokens.color.white,
    borderColorPress: tokens.color.red8,
  },
}
